import { render, staticRenderFns } from "./CabinetTransferPassBook.vue?vue&type=template&id=6b354540&scoped=true&"
import script from "./CabinetTransferPassBook.vue?vue&type=script&lang=js&"
export * from "./CabinetTransferPassBook.vue?vue&type=script&lang=js&"
import style0 from "./CabinetTransferPassBook.vue?vue&type=style&index=0&id=6b354540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b354540",
  null
  
)

export default component.exports